<template>
  <div>
    <ForgetPassword />
  </div>
</template>

<script>
import ForgetPassword from "@/components/Account/ForgetPassword.vue";
export default {
  components: {
    ForgetPassword,
  },
};
</script>

<style></style>
